import Box from "@/components/Box";
import { ExternalTextLink } from "@/components/Links";
import learningHubLunchAndLearnsImage from "@/images/learningHubLunchAndLearns.png";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import {
  dashboardActionButtonSize,
  dashboardHeaderRowGap,
  dashboardSectionBody,
  dashboardSectionLabel,
  dashboardSectionTitle,
  learningHubDashboardLunchAndLearnsContentPb,
  learningHubDashboardLunchAndLearnsContentPl,
  learningHubDashboardLunchAndLearnsContentPr,
  learningHubDashboardLunchAndLearnsContentPt,
  lhDashboardBp,
  lhDashboardPageInset
} from "./dashboardLayout";

const LUNCH_AND_LEARNS_BOOKING_URL =
  "https://app.acuityscheduling.com/schedule/a4df7d3b?calendarIds=10270844";

export default function LunchAndLearnsSection() {
  return (
    <Stack bg="white" borderRadius={20} overflow="hidden">
      <Group
        flexDirection={lhDashboardPageInset("column", "column", "column", "row")}
        gap={lhDashboardPageInset(dashboardHeaderRowGap[0], 0, dashboardHeaderRowGap[0], 0)}
        alignItems="stretch"
      >
        <Stack
          gap={lhDashboardBp(24, 32, 24)}
          width={lhDashboardPageInset("100%", "100%", "100%", "50%")}
          flex={1}
          alignSelf="stretch"
          order={lhDashboardPageInset(2, 2, 2, 1)}
          pt={learningHubDashboardLunchAndLearnsContentPt}
          pr={learningHubDashboardLunchAndLearnsContentPr}
          pb={learningHubDashboardLunchAndLearnsContentPb}
          pl={learningHubDashboardLunchAndLearnsContentPl}
          justifyContent={lhDashboardPageInset(
            "flex-start",
            "flex-start",
            "flex-start",
            "space-between"
          )}
        >
          <Stack gap={0}>
            <Box {...dashboardSectionTitle} fontSize={lhDashboardBp(28, 32, 36)}>
              Lunch & Learns
            </Box>
            <Stack gap={lhDashboardBp(24, 20, 40)} mt={16}>
              <Box {...dashboardSectionBody} fontSize={lhDashboardBp(16, 18, 18)}>
                Build your confidence in functional testing with our practical, two-part Lunch &
                Learns. Learn the fundamentals in Part 1, then put them into practice with real case
                studies in Part 2 – with exclusive practitioner test discounts available too.
              </Box>
              <Stack gap={2}>
                <Box {...dashboardSectionLabel}>Choose from:</Box>
                <Box {...dashboardSectionBody} fontSize={lhDashboardBp(16, 18, 18)}>
                  GI360 | HuMap | OAT | DUTCH | Cyrex | GutIQ | NutriStat
                </Box>
              </Stack>
            </Stack>
          </Stack>
          <ButtonV2
            color="dark"
            size={dashboardActionButtonSize}
            as={ExternalTextLink}
            href={LUNCH_AND_LEARNS_BOOKING_URL}
            underline={false}
            sx={{ alignSelf: "flex-start", mt: [4, 4, 6] }}
          >
            explore tests
          </ButtonV2>
        </Stack>
        <Box
          as="img"
          src={learningHubLunchAndLearnsImage}
          alt="Person taking notes during a Lunch & Learn session"
          width={lhDashboardPageInset("100%", "100%", "100%", "50%")}
          flex={1}
          order={lhDashboardPageInset(1, 1, 1, 2)}
          maxHeight={lhDashboardPageInset(328, null, null, "unset")}
          minHeight={lhDashboardBp(null, null, 280)}
          sx={{
            objectFit: "cover",
            display: "block"
          }}
          style={{ objectFit: "cover" }}
        />
      </Group>
    </Stack>
  );
}
